var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pt-4",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('close-app-logo'),_c('div',{staticClass:"title-page font-weight-medium"},[_vm._v(_vm._s(_vm.title))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }